// Credentials file generation for LLM API integrations.
// Builds the connection key and triggers a JSON file download.

export interface CredentialsFile {
  format: number
  connection_key: string
  api_key: string
  server: string
  tenant_id: string
  openapi_spec_url: string
  generated: string
  note: string
}

/**
 * Build a credentials file object from the raw key and tenant context.
 * The server hostname is derived from the current page URL.
 */
export function buildCredentialsFile(tenantId: string, apiKey: string): CredentialsFile {
  const server = window.location.host // includes port if non-standard
  return {
    format: 1,
    connection_key: `rqc:${server}:${tenantId}:${apiKey}`,
    api_key: apiKey,
    server,
    tenant_id: tenantId,
    openapi_spec_url: `${window.location.origin}/api/v1/llm/openapi.yaml`,
    generated: new Date().toISOString(),
    note: 'Store securely. This file cannot be re-downloaded. Revoke and regenerate if lost.',
  }
}

/**
 * Trigger a browser download of the credentials file.
 * File is named riskquilt-api-key-{prefix}.json where prefix is the first 8 chars.
 */
export function downloadCredentialsFile(creds: CredentialsFile, keyPrefix: string): void {
  const json = JSON.stringify(creds, null, 2)
  const blob = new Blob([json], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `riskquilt-api-key-${keyPrefix}.json`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
